import { IframeController } from './iframe-controller';

/**
 * Module for managing iframe view operations
 * Provides a clean API that delegates to the unified IframeController
 */
export class ViewModule {
  private sdk: any;

  constructor(sdk: any) {
    this.sdk = sdk;
  }

  private get controller(): IframeController {
    return this.sdk.overlay as IframeController;
  }

  /**
   * Notify launcher controller to update positioning after state changes
   */
  private notifyLauncherUpdate(): void {
    if (this.sdk.launcher && this.sdk.launcher.updateIframePositioning) {
      this.sdk.launcher.updateIframePositioning();
    }
  }

  // Visibility Management

  /**
   * Shows the iframe overlay
   */
  public async showView(): Promise<void> {
    this.controller.show();
  }

  /**
   * Hides the iframe overlay
   */
  public async hideView(): Promise<void> {
    this.controller.hide();
  }

  /**
   * Toggles iframe visibility (show/hide)
   */
  public async toggleVisibility(): Promise<void> {
    this.controller.toggleVisibility();
  }

  // State Inspection

  /**
   * Gets the current visibility state
   */
  public isViewVisible(): boolean {
    return this.controller.isOverlayVisible();
  }

  /**
   * Checks if currently in mobile mode
   */
  public isMobileMode(): boolean {
    return this.controller.isMobileMode();
  }

  // Navigation Management

  /**
   * Navigate to a specific route within the iframe
   * @param route - The route/path to navigate to (e.g., '/login', '/dashboard')
   */
  public async navigateToRoute(route: string): Promise<void> {
    if (!route) {
      console.warn('⚠️ [ViewModule] navigateToRoute called with empty route');
      return;
    }

    this.controller.navigateToRoute(route);
  }
}
